import React from 'react';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import AppTheme from './components/shared-theme/AppTheme';
import SignIn from './pages/Auth/SignIn';
import Register from './pages/Auth/Register';
import OTPVerification from './pages/Auth/OTPVerification';
import Dashboard from './pages/PrivateRoute/Dashboard/Dashboard.js';
import TopThreeConnection from './pages/PrivateRoute/TopThree&Connection/TopThreeConnection.js';
import MobileGames from './pages/PrivateRoute/MobileGames/MobileGames.js';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import ErrorBoundary from './utils/ErrorBoundary.js';
import { CircularProgress } from '@mui/material';
import { useAuth } from './context/AuthContext';
import ProductsMark from './pages/PrivateRoute/Products/ProductsMark.js';
import AddressMark from './pages/PrivateRoute/AddressMark/AddressMark.js';
import NotFound from './pages/PrivateRoute/NotFound/NotFound.js';
import MarketingKit from './pages/PrivateRoute/MarketingKit/MarketingKit.js';
import BookingOrder from './pages/PrivateRoute/BookingOrder/BookingOrder.js';
import PriceList from './pages/PrivateRoute/PriceList/PriceList.js';
import FAQs from './pages/PrivateRoute/FAQs/FAQs.js';
import SupportKit from './pages/PrivateRoute/SupportKit/SupportKit.js';
import Transaksi from './pages/PrivateRoute/Transaksi/Transaksi.js';
import RecruitAgent from './pages/PrivateRoute/RecruitAgent/RecruitAgent.js';
import Profile from './pages/PrivateRoute/Profile/Profile.js';

function App() {
  return (
    <AppTheme>
      <ErrorBoundary>
        <Routes>
          <Route path="/signin" element={<SignIn />} />
          <Route path="/register" element={<Register />} />
          <Route path="/otp" element={<OTPVerification />} />
          <Route path="/home" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/connection" element={<PrivateRoute><TopThreeConnection /></PrivateRoute>} />
          <Route path="/products" element={<PrivateRoute><ProductsMark /></PrivateRoute>} />
          <Route path="/address" element={<PrivateRoute><AddressMark /></PrivateRoute>} />
          <Route path="/marketing-kit" element={<PrivateRoute><MarketingKit /></PrivateRoute>} />
          <Route path="/faq" element={<PrivateRoute><FAQs /></PrivateRoute>} />
          <Route path="/booking" element={<PrivateRoute><BookingOrder /></PrivateRoute>} />
          <Route path="/price-list" element={<PrivateRoute><PriceList /></PrivateRoute>} />
          <Route path="/bantuan" element={<PrivateRoute><SupportKit /></PrivateRoute>} />
          <Route path="/transaction" element={<PrivateRoute><Transaksi /></PrivateRoute>} />
          <Route path="/recruit-agent" element={<PrivateRoute><RecruitAgent /></PrivateRoute>} />
          <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
          <Route path="/games/:category" element={<PrivateRoute><MobileGames /></PrivateRoute>} />
          <Route path="/" element={<RedirectToAuth />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </ErrorBoundary>
    </AppTheme>
  );
}

function PrivateRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation(); // Get the current route

  // Skip loading for public routes like /register or /signin
  if (loading && !['/signin', '/register', '/otp'].includes(location.pathname)) {
    return <CircularProgress />; // Show a loader during the initial auth check
  }

  console.log('Private Route Authenticated:', isAuthenticated); // Debugging

  if (!isAuthenticated && !['/signin', '/register'].includes(location.pathname)) {
    return <Navigate to="/signin" />;
  }

  return children;
}

function RedirectToAuth() {
  const { isAuthenticated, loading } = useAuth();

  // Skip loading for public routes like /signin or /register
  if (loading) {
    return <CircularProgress />; // Show a loader during the initial auth check
  }

  return isAuthenticated ? <Navigate to="/home" /> : <Navigate to="/signin" />;
}

export default App;
